export default {
  setFirstName(state, value) {
    state.FirstName = value;
  },
  setLastName(state, value) {
    state.LastName = value;
  },
  setEmail(state, value) {
    state.Email = value;
  },
  setNewsletterOptIn(state, value) {
    state.NewsletterOptIn = value;
  },
  setYear(state, value) {
    state.Year = value;
  },
  setMake(state, value) {
    state.Make = value;
  },
  setModel(state, value) {
    state.Model = value;
  },
  setTrim(state, value) {
    state.Trim = value;
  },
  setYearLabel(state, value) {
    state.YearLabel = value;
  },
  setMakeLabel(state, value) {
    state.MakeLabel = value;
  },
  setModelLabel(state, value) {
    state.ModelLabel = value;
  },
  setTrimLabel(state, value) {
    state.TrimLabel = value;
  },
  setTireWidth(state, value) {
    state.TireWidth = value;
  },
  setTireAspect(state, value) {
    state.TireAspect = value;
  },
  setTireDiameter(state, value) {
    state.TireDiameter = value;
  },
  setTireName(state, value) {
    state.TireName = value;
  },
  setShirtSize(state, value) {
    state.ShirtSize = value;
  },
  setHatSize(state, value) {
    state.HatSize = value;
  },
  setJacketSize(state, value) {
    state.JacketSize = value;
  },
  setAddressLine1(state, value) {
    state.AddressLine1 = value;
  },
  setCity(state, value) {
    state.City = value;
  },
  setState(state, value) {
    state.State = value;
  },
  setZipCode(state, value) {
    state.ZipCode = value;
  },
  setPhone(state, value) {
    state.Phone = value;
  },
  setEnthusiastType(state, value) {
    state.EnthusiastType = value;
  },
  setAdditionalInfo(state, value) {
    state.AdditionalInfo = value;
  },
  setSessionId(state, value) {
    state.SessionId = value;
  },
};
